import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { Button } from "@design-system/Button/Button";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ViewTableMeta } from "@hooks/view/useViewTableMeta";
import viewTableStyles from "@design-system/ViewTable/ViewTable.module.scss";
import type { ApplyCoaTemplateEntitySelectionRow } from "../applyCoaTemplateEntitySelection.types";

export interface ApplyCoaEntityOpenCallbacks {
    onOpenEntity: (params: { workspaceId: string; entityId: number }) => void;
}

type Meta = ViewTableMeta<ApplyCoaEntityOpenCallbacks, never>;

// Pinned-right "Open" action for an applied entity row (opens the entity's
// Chart of Accounts). Workspace rows render an empty cell. Used only by the
// applied-entities drawer, which supplies the `onOpenEntity` callback.
export const ApplyCoaEntityOpenCell = memo(
    ({
        row,
        table,
    }: CellContext<
        ViewTableFeatures,
        ApplyCoaTemplateEntitySelectionRow,
        unknown
    >) => {
        const { isClientRow, workspaceId, entityId } = row.original;
        if (isClientRow || entityId === null) {
            return <ViewTableCell />;
        }

        const meta = (table.options.meta ?? {}) as Meta;

        return (
            <ViewTableCell captureClicks>
                <Button
                    variant="primary"
                    size="sm"
                    className={viewTableStyles.showOnHover}
                    onClick={() =>
                        meta.callbacks?.onOpenEntity({ workspaceId, entityId })
                    }
                >
                    Open
                </Button>
            </ViewTableCell>
        );
    },
);
